import { runPendingAnalyticalRequests } from "./events/eventRequests.js";
import { isBrowser } from "./utils/index.js";
import { KlevuUserSession } from "./usersession.js";
import { Klaviyo } from "./connectors/klaviyo.js";
import { KlevuDomEvents } from "./events/KlevuDomEvents.js";
export class KlevuConfig {
    constructor(config) {
        var _a;
        this.cacheMaxTTL = 600000;
        this.eventsApiV1Url = "https://stats.ksearchnet.com/analytics/";
        this.eventsApiV2Url = "https://stats.ksearchnet.com/analytics/collect";
        this.recommendationsApiUrl = "https://config-cdn.ksearchnet.com/recommendations/";
        this.visitorServiceUrl = "https://visitor.service.ksearchnet.com/public/1.0";
        this.moiApiUrl = "https://moi-ai.ksearchnet.com/";
        this.disableClickTracking = false;
        this.enableKlaviyoConnector = false;
        this.useConsent = false;
        this.consentGiven = false;
        this.apiKey = config.apiKey;
        this.url = config.url;
        if (config.moiApiUrl) {
            this.moiApiUrl = config.moiApiUrl;
        }
        if (config.cacheMaxTTL) {
            this.cacheMaxTTL = config.cacheMaxTTL;
        }
        if (config.axios) {
            this.axios = config.axios.create();
        }
        if (config.eventsApiV1Url) {
            this.eventsApiV1Url = config.eventsApiV1Url;
        }
        if (config.eventsApiV2Url) {
            this.eventsApiV2Url = config.eventsApiV2Url;
        }
        if (config.visitorServiceUrl) {
            this.visitorServiceUrl = config.visitorServiceUrl;
        }
        if (config.recommendationsApiUrl) {
            this.recommendationsApiUrl = config.recommendationsApiUrl;
        }
        this.disableClickTracking = (_a = config.disableClickTrackStoring) !== null && _a !== void 0 ? _a : false;
        this.useConsent = config.useConsent || false;
        this.consentGiven = config.consentGiven || false;
        this.enableKlaviyoConnector = config.enableKlaviyoConnector || false;
    }
    static init(config) {
        KlevuConfig.default = new KlevuConfig(config);
        runPendingAnalyticalRequests();
        KlevuUserSession.init();
        if (KlevuUserSession.getDefault().hasSessionExpired()) {
            KlevuUserSession.getDefault()
                .generateSession()
                .then(() => {
                if (this.getDefault().enableKlaviyoConnector) {
                    Klaviyo.init();
                }
            });
        }
        else {
            KlevuUserSession.getDefault().setExpiryTimer();
            if (this.getDefault().enableKlaviyoConnector) {
                Klaviyo.init();
            }
        }
    }
    static getDefault() {
        if (!KlevuConfig.default) {
            throw new Error("Configuration missing");
        }
        return KlevuConfig.default;
    }
    isConsentDisallowed() {
        return this.useConsent && !this.consentGiven;
    }
    setUseConsent(useConsent) {
        this.useConsent = useConsent;
        if (typeof document !== "undefined") {
            document.dispatchEvent(new CustomEvent(KlevuDomEvents.UseConsentChanged, {
                detail: {
                    useConsent,
                },
            }));
        }
    }
    setEnableKlaviyoConnector(val) {
        this.enableKlaviyoConnector = val;
        if (val) {
            Klaviyo.init();
        }
    }
    setConsentGiven(userConsent) {
        this.consentGiven = userConsent;
        if (userConsent)
            KlevuUserSession.getDefault().generateSession();
        if (typeof document !== "undefined") {
            document.dispatchEvent(new CustomEvent(KlevuDomEvents.UserConsentGivenChanged, {
                detail: {
                    userConsent,
                },
            }));
        }
    }
}
KlevuConfig.default = loadFromGlobal();
function loadFromGlobal() {
    if (!isBrowser()) {
        return undefined;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const cfg = window.KlevuConfig;
    if (!cfg) {
        return undefined;
    }
    return new KlevuConfig(cfg);
}
